/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TypeEnum = "CART" | "HOMEPAGE" | "%future added value";
export type AvailableDiscountsQueryVariables = {|
  listType: TypeEnum
|};
export type AvailableDiscountsQueryResponse = {|
  +availableDiscounts: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +code: string,
    +description: ?string,
  |}>
|};
export type AvailableDiscountsQuery = {|
  variables: AvailableDiscountsQueryVariables,
  response: AvailableDiscountsQueryResponse,
|};
*/


/*
query AvailableDiscountsQuery(
  $listType: TypeEnum!
) {
  availableDiscounts(listType: $listType) {
    id
    name
    code
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "listType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "listType",
        "variableName": "listType"
      }
    ],
    "concreteType": "DiscountType",
    "kind": "LinkedField",
    "name": "availableDiscounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AvailableDiscountsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AvailableDiscountsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5dbf90d755270dedd30ef057577419f5",
    "id": null,
    "metadata": {},
    "name": "AvailableDiscountsQuery",
    "operationKind": "query",
    "text": "query AvailableDiscountsQuery(\n  $listType: TypeEnum!\n) {\n  availableDiscounts(listType: $listType) {\n    id\n    name\n    code\n    description\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '849644c5045e0f2bbe0d5385cf35f540';

module.exports = node;
